import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { fetchJson } from '../../../../store/fetch';
import { Button } from '../../atoms/buttons/button/Button';
import { Figure } from '../../atoms/figure/Figure';
import { ButtonContainer } from '../../molecules/buttonContainer/ButtonContainer';

interface ILoginFormProps {
    autoSend?: boolean;
    relayState?: string;
    submitButtonText: string;
}

export function LoginForm(props: ILoginFormProps) {
    const [loginUrl, setLoginUrl] = useState('');
    const [samlRequest, setSamlRequest] = useState('');

    useEffect(() => {
        const autoLogin = async () => {
            if (props.autoSend) {
                await setTimeout(async () => onLogin(), 100);
            }
        };
        autoLogin();
    }, []);

    return (
        <form
            action={loginUrl}
            id="saml-login-form"
            method="post"
        >
            <input
                name="SAMLRequest"
                type="hidden"
                value={samlRequest}
            />
            <input
                name="RelayState"
                type="hidden"
                value={props.relayState}
            />
            {!props.autoSend && (
                <ButtonContainer
                    buttons={[
                        <Button
                            className="flex"
                            key={0}
                            onClick={async () => await onLogin()}
                        >
                            {props.submitButtonText}
                        </Button>,
                        <Button
                            className="no-padding"
                            isButtonLink
                            key={1}
                            onClick={async () => await onLogin()}
                        >
                            <Figure
                                alt="Logo digid"
                                className="m-0"
                                fixedSquareSizes="is-48x48"
                                imageUrl="/assets/images/digid.png"
                            />
                        </Button>,
                    ]}
                />
            )}
        </form>
    );

    async function getAuthRequest() {
        const result = await fetchJson('/saml/authRequest', 'GET');
        if (result.json.samlRequest && result.json.url) {
            return result.json;
        } else {
            throw new Error('Error getting the auth request');
        }
    }

    function submitSamlForm() {
        const samlLoginForm = document.getElementById('saml-login-form') as HTMLFormElement;
        if (samlLoginForm) {
            samlLoginForm.submit();
        } else {
            throw new Error('Auth form missing');
        }
    }

    async function onLogin() {
        const samlData = await getAuthRequest();
        flushSync(() => {
            setLoginUrl(samlData.url);
            setSamlRequest(samlData.samlRequest);
        });
        submitSamlForm();
    }
}
